import LogoSection from './LogoSection';
import useLogoutFn from '@/hooks/useLogoutFn';
import { useEffect } from 'react';
import { SidebarTrigger } from '@layout/Sidebar/Sidebar';
import HeaderActions from './HeaderActions';
import { useTailwindBreakpoint } from '@eye-able/ui';

function Header() {
  const xlAndUp = useTailwindBreakpoint('xl');
  const logoutFn = useLogoutFn();

  useEffect(() => {
    function logoutOtherTabs(event: StorageEvent) {
      if (event.key === 'logout') {
        void logoutFn(true);
      }
    }

    window.addEventListener('storage', logoutOtherTabs);

    return () => {
      window.removeEventListener('storage', logoutOtherTabs);
    };
  }, [logoutFn]);

  return (
    <header className='eye:bg-white eye:fixed eye:top-0 eye:left-0 eye:w-full eye:z-1299 eye:h-[52px] eye:xl:h-[75px] eye:flex eye:border-b eye:border-solid eye:border-grey-20 eye:px-12 eye:xl:px-48 eye:items-center eye:justify-between'>
      <div className='eye:flex eye:items-center'>
        <LogoSection dark />
      </div>
      {xlAndUp ? <HeaderActions /> : <SidebarTrigger />}
    </header>
  );
}

export default Header;
